import React from 'react'
import Card from '@components/V3/Card'

import Address, {AddressSkeleton} from './Address'
import CancelledInfo from './CancelledInfo'
import DelayWarning from './DelayWarning'
import DeliveredAt from './DeliveredAt'
import DeliverySecretCode from './DeliverySecretCode'
import InReview from './InReview'
import IssuesWithOrder from './IssuesWithOrder'
import TrackingLoyalty from './Loyalty'
import NotConfirmedInTime from './NotConfirmedInTime'
import OlderThan18Warning from './OlderThan18Warning'
import PaymentNotReady from './PaymentNotReady'
import PickupDirections from './PickupDirections'
import Schedule, {ScheduleSkeleton} from './Schedule'
import ScheduledWarning from './ScheduledWarning'
import Status, {StatusSkeleton} from './Status'
import Table from './Table'
import TrackTimeline, {TrackTimelineSkeleton} from './TrackTimeline'

export const MainSkeleton = () => (
  <Card transparentOnDesktop desktopThreshold="lg">
    <div className="flex flex-col gap-4 px-4">
      <TrackTimelineSkeleton />
      <StatusSkeleton />
      <ScheduleSkeleton />
      <AddressSkeleton />
    </div>
  </Card>
)

export default function Main() {
  return (
    <Card transparentOnDesktop desktopThreshold="lg">
      <div className="flex flex-col gap-4 px-4">
        <TrackTimeline />
        <Status />
        <InReview />
        <DeliverySecretCode />
        <ScheduledWarning />
        <PaymentNotReady />
        <DelayWarning />
        <OlderThan18Warning />
        <NotConfirmedInTime />
        <DeliveredAt />
        <CancelledInfo />
        <Schedule />
        <Table />
        <PickupDirections />
        <Address />
        <IssuesWithOrder />
        <TrackingLoyalty />
      </div>
    </Card>
  )
}
